import type { ChatFetchers } from '../../fetchers/chat/chat-fetchers';
import { useApplicationFetchers } from '../../fetchers/use-application-fetchers';

export const useCancelChatTurn = (): ChatFetchers['cancelChatTurn'] => useApplicationFetchers().cancelChatTurn;
